// Helper utility for generating device and web calendar events (Google, Outlook, ICS)

export const formatCalendarDate = (date) => {
    const d = new Date(date);
    return d.toISOString().replace(/-|:|\.\d\d\d/g, '');
};

export const generateGoogleCalendarUrl = ({
    title = 'Evento Pfizer',
    description = 'Confirmación de asistencia al evento',
    location = 'Perú',
    startTime = new Date(),
    endTime = new Date(Date.now() + 3600000)
}) => {
    const startIso = formatCalendarDate(startTime);
    const endIso = formatCalendarDate(endTime);
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: title,
        details: description,
        location: location,
        dates: `${startIso}/${endIso}`
    });
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const generateOutlookCalendarUrl = ({
    title = 'Evento Pfizer',
    description = 'Confirmación de asistencia al evento',
    location = 'Perú',
    startTime = new Date(),
    endTime = new Date(Date.now() + 3600000)
}) => {
    const params = new URLSearchParams({
        path: '/calendar/action/compose',
        rru: 'addevent',
        subject: title,
        body: description,
        location: location,
        startdt: new Date(startTime).toISOString(),
        enddt: new Date(endTime).toISOString()
    });
    return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
};

export const downloadIcsFile = ({
    title = 'Evento Pfizer',
    description = 'Confirmación de asistencia al evento',
    location = 'Perú',
    startTime = new Date(),
    endTime = new Date(Date.now() + 3600000)
}) => {
    const startIso = formatCalendarDate(startTime);
    const endIso = formatCalendarDate(endTime);
    
    const csContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Pfizer Event App//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
        `DTSTART:${startIso}`,
        `DTEND:${endIso}`,
        `STATUS:CONFIRMED`,
        'END:VEVENT',
        'END:VCALENDAR'
    ].join('\r\n');

    const blob = new Blob([csContent], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', 'evento-pfizer.ics');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
